export default __webpack_public_path__ + "static/media/6.5c0d40b1.png";